import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class BookingGetTemporaryResponse {
  @IsOptional()
  @IsString()
  @Expose()
  recordLocator: string | null = null;
  @IsOptional()
  @IsNumber()
  @Expose()
  gdsId: number | null = null;
  @IsBoolean()
  @Expose()
  canEdit = false;
}
